import React, { useCallback, useState } from 'react';

import CreateAcademyProjectModal from '../CreateAcademyProjectModal';
import ToggleChip from 'components/ToggleChip';

export default function AcademyProjectChip({ academyTopic }) {
  const [modalOpen, setModalOpen] = useState(false);
  const { id: academyTopicId } = academyTopic || {};

  const handleModalOpen = useCallback(() => {
    setModalOpen(true);
  }, []);

  const handleModalClose = useCallback(() => {
    setModalOpen(false);
  }, []);

  return (
    <>
      <CreateAcademyProjectModal
        academyTopicId={academyTopicId}
        handleClose={handleModalClose}
        isOpen={modalOpen}
      />
      <ToggleChip
        label="Add Case Study"
        onAdd={handleModalOpen}
        className="m-r-xs m-b-xxs"
      />
    </>
  );
}
